import React from 'react'
import { useState, useEffect } from 'react'
import './css/Card.css'
import { retrieveShelterInfo } from './Firebase'
import 'bootstrap/dist/css/bootstrap.css';

export default function Card({id,title,imageUrl,body,sex,size,age,shelterId}) {

    const [filterState, setFilterState] = useState(false);
    const [email, setEmail]= useState("undefined");
    const [phone, setPhone]= useState("undefined");
    const [website, setWebsite]= useState("undefined");
    const [address, setAddress]= useState("undefined");
    const [shelterName, setShelterName]= useState("undefined");
    const [logoURL, setLogoURL]= useState("undefined");


    const safeTest = async () => {
        
        const shelter = await retrieveShelterInfo(shelterId);
        const shelterInfo = shelter.data();
        
        console.log(shelterInfo)
        console.log('getting here')
        if (shelterInfo === 'undefined') {
        } else {
            setEmail(shelterInfo.email);
            setPhone(shelterInfo.number);
            setWebsite(shelterInfo.website);
            setAddress(shelterInfo.address);
            if(shelterInfo.name === "Capital Area Animal Welfare Society"){
              setShelterName("CAAWS");
            }else
              setShelterName(shelterInfo.name);
    
            setLogoURL(shelterInfo.logoURL);
        }
       }

    useEffect(async () => {
        safeTest();
      },[])


    return (filterState) ? (
        <div className = "popupCard">

            <div className = "popup-innerCard">
                <div>
                    
                    <button className = "close-btnCard" onClick={() => setFilterState(false)}>X</button>
                    <div className = "column">
                    <img className = 'imgPopClass'src={imageUrl} alt=''/>
                    </div>
                    <div className = "column2">
                    <h1>{title}</h1>
                    <h3>Breed: {body}</h3>
                    <h3>Sex: {sex}</h3>
                    <h3>Size: {size}</h3>
                    <h3>Age: {age}</h3>
                    </div>
                    <div className = "shelterInfo">
                    <img className = 'logo'src={logoURL} alt=''/>
                    <h1 className = "shelterText">{shelterName}</h1>
                    <h2 className = "shelterText">Ask About ME!</h2>
                    <h4 className = "shelterText">Email: {email}</h4>
                    <h4 className = "shelterText">Phone: {phone}</h4>
                    <h4 className = "shelterText">Website: {website}</h4>
                    <h2 className = "shelterText">Come See ME!</h2>
                    <h4 className = "shelterText">Address: {address}</h4>
                    </div>
                    <br></br>

                </div>
            </div>
        </div>
    ) :
        <>
        <div className = 'card-container'>
            <div className = 'image-container'>
                <img className = 'imgClass'src={imageUrl} alt=''/>
            </div>
            <div className = 'card-title'>
                <h3>{title}</h3>
                <h6>Breed: {body}</h6>
            </div>

            <div className = 'btn'>
                <button onClick={() => setFilterState(true)}>
                        View more
                </button>
            </div>
        </div>
        </>
    
}
